export default __webpack_public_path__ + "static/media/bialko-icon.2c148d0e.svg";